import { createSelector } from 'reselect';
import { name, initialState } from './slice';

export const logisticOperatorsSelector = (state) => state[name] || initialState;

export const logisticOperatorsObjectItemSelector = (state) => state[name].items;

export const logisticOperatorsItemsSelector = createSelector(
  logisticOperatorsObjectItemSelector,
  (items) => Object.values(items),
);

export const logisticOperatorsLoadedSelector = (state) => state[name].loaded;

const makeLogisticOperatorSelector = () =>
  createSelector(logisticOperatorsSelector, (substate) => substate);

export default makeLogisticOperatorSelector;
